module.exports = __webpack_public_path__ + "img/Bellflower.3c56b6e1.jpeg";